/* eslint-disable no-undef */
jQuery(document).ready(($) => {
  const wooCarrierAgents = {
    postcode: null,
    agents: [],
    maxResults: 5,
    kcoInit: false,

    init() {
      const self = this;

      this.loadCookies();

      this.autoRefreshAgents();
      this.showMoreAgents();

      this.triggerSearch();

      this.setAgent();
      this.selectAgent();

      // THIS IS ENERVENT MODIFIED
      // this.saveSearchPostcode();

      if (this.isKlarnaCheckout() || this.isKlarnaCheckoutV3()) {
        this.triggerUpdateKcoAddress();
        this.initKcoPostcode();

        $(document.body).on('update_checkout', () => {
          if (self.toggleAgents()) {
            self.searchAgents();
          }
        });
      } else {
        this.autoUpdatePostcode();

        $(document.body).on('init_checkout', () => {
          if (self.toggleAgents()) {
            self.searchAgents();
          }
        });

        $(document.body).on('updated_checkout', () => {
          if (self.toggleAgents()) {
            self.searchAgents();
          }
        });
      }
    },

    /**
     * Load selected agent ID and max results from cookies
     */
    loadCookies() {
      this.postcode = Cookies.get('wca_postcode');
      this.maxResults = Cookies.get('wca_max_results');

      if (typeof this.postcode === 'undefined' || this.postcode == null) {
        this.postcode = this.getShippingPostcode();
      }

      if (typeof this.maxResults === 'undefined' || this.maxResults == null) {
        this.maxResults = 5;
      }

      $('input[name="woo-carrier-agents-postcode"]')
        .val(this.postcode)
        .trigger('change');
    },

    /**
     * Update search postcode when changing postcode in the checkout form
     */
    autoUpdatePostcode() {
      const self = this;

      $(document).on(
        'change',
        'input#billing_postcode, input#shipping_postcode',
        () => {
          const postcode = self.getShippingPostcode();

          $('input[name="woo-carrier-agents-postcode"]')
            .val(postcode)
            .trigger('change');
          self.searchAgents();
        }
      );
    },

    /**
     * Trigger address change when changing Klarna address
     */
    triggerUpdateKcoAddress() {
      const self = this;

      $(document.body).on('kco_shipping_address_changed', () => {
        const postcode = $('#shipping_postcode').val();

        $('input[name="woo-carrier-agents-postcode"]')
          .val(postcode)
          .trigger('change');
        self.searchAgents();
      });
    },

    /**
     * Shows error messages
     */
    showErrors() {
      const validPostcode = !!this.validPostcode(this.getSearchPostcode());
      let errorMsg = false;

      this.resetErrorMessages();

      if (!validPostcode) {
        errorMsg = wooCarrierAgentsAjax.errors.invalid_postcode;
      } else if (this.carrierErrors.length > 0) {
        errorMsg = this.carrierErrors.join('<br>');
      } else if (this.agents.length === 0) {
        errorMsg = wooCarrierAgentsAjax.errors.no_agents;
      }

      if (errorMsg !== false) {
        $('.woo-carrier-agents-error-msg').html(errorMsg);
        $('#woo-carrier-agents-container').addClass('has-error');
      }
    },

    /**
     * Reset all error messages
     */
    resetErrorMessages() {
      $('#woo-carrier-agents-container').removeClass('has-error');
    },

    /**
     * Get shipping postcode
     */
    getShippingPostcode() {
      let postcode = $('input#billing_postcode').val();

      if ($('#ship-to-different-address').find('input').is(':checked')) {
        const shippingPostcode = $('input#shipping_postcode').val();
        if (shippingPostcode) {
          postcode = shippingPostcode;
        }
      }

      return postcode;
    },

    /**
     * Get shipping country
     */
    getShippingCountry() {
      if (this.isKlarnaCheckoutV3()) {
        if (wooCarrierAgentsShippingCountry) {
          return wooCarrierAgentsShippingCountry;
        }
        if ($('#shipping_country').length > 0) {
          const country = $('#shipping_country').val();
          return country;
        }

        return 'FI';
      }

      if ($('#billing_country').length > 0) {
        let country = $('#billing_country').val();

        if ($('#ship-to-different-address').find('input').is(':checked')) {
          country = $('#shipping_country').val();
        }

        return country;
      }

      return 'FI';
    },

    /**
     * Checks whether postcode is valid
     */
    validPostcode(code) {
      const country = this.getShippingCountry();

      if (country === 'FI' || country === 'AX') {
        const postcode = String(code).trim();

        return postcode && postcode.length === 5 && /^\d+$/.test(postcode);
      }
      if (country === 'SE') {
        const postcode = String(code).trim().replace(/\s/g, '');

        return postcode && postcode.length === 5 && /^\d+$/.test(postcode);
      }

      if (country === 'NO') {
        const postcode = String(code).trim().replace(/\s/g, '');

        return postcode && postcode.length === 4 && /^\d+$/.test(postcode);
      }

      return true;
    },

    /**
     * Checks if we are using Klarna Checkout
     */
    isKlarnaCheckout() {
      return $('.klarna_checkout').length > 0;
    },

    /**
     * Checks if we are using Klarna Checkout V3
     */
    isKlarnaCheckoutV3() {
      return $('#klarna-checkout-container').length > 0;
    },

    /**
     * Automatically refresh agents when a valid postcode has been entered
     */
    autoRefreshAgents() {
      const self = this;

      $(document).on(
        'keyup',
        'input[name="woo-carrier-agents-postcode"]',
        (e) => {
          const postcode = String(e.target.defaultValue).trim();

          const validPostcode = self.validPostcode(postcode);

          // Toggle error msgs
          self.showErrors();

          if (validPostcode) {
            self.resetErrorMessages();
            $('a#woo-carrier-agents-search-button').trigger('click');
          }
        }
      );
    },

    /**
     * Render agents
     */
    renderAgents() {
      const agentTemplate = wp.template('woo-carrier-agent');

      // Empty current agent list
      $('#woo-carrier-agents').html('');

      const instanceId = this.getShippingMethodInstanceId();

      if (instanceId !== null) {
        const limit = Math.min.apply(Math, [
          this.agents.length,
          this.maxResults,
        ]);

        for (let i = 0; i < limit; i += 1) {
          $('#woo-carrier-agents').append(
            agentTemplate({
              agent: this.agents[i],
              instance_id: instanceId,
            })
          );
        }

        // Set default value
        this.setDefaultAgent();

        // Toggle show more button
        this.toggleShowMore();

        // Toggle error messages
        this.showErrors();
      }
    },

    /**
     * Init search for Klarna Checkout
     */
    initKcoPostcode() {
      const self = this;

      $(document.body).on('updated_checkout', () => {
        if (self.kcoInit === false) {
          self.loadCookies();

          if (self.toggleAgents()) {
            self.searchAgents();
          }

          self.kcoInit = true;
        }
      });
    },

    /**
     * Trigger search when clicking the button
     */
    triggerSearch() {
      const self = this;

      $(document).on('click', 'a#woo-carrier-agents-search-button', (e) => {
        e.preventDefault();

        self.maxResults = 5;
        Cookies.set('wca_max_results', self.maxResults);
        self.searchAgents();
      });
    },

    /**
     * Fetch agents via AJAX
     */
    searchAgents() {
      this.carrierErrors = [];
      const self = this;
      const data = {
        action: 'wca_fetch_agents',
        postcode: $('input[name="woo-carrier-agents-postcode"]').val(),
        country: this.getShippingCountry(),
        shipping_method: this.getShippingMethod(),
      };

      jQuery.ajax({
        url: wooCarrierAgentsAjax.resturl,
        data,
        method: 'POST',
        beforeSend() {
          $('#woo-carrier-agents-throbber').show();
        },
        success(response) {
          self.agents = response.agents;
          self.carrierErrors = response.errors;
          self.renderAgents();
        },
        error() {
          self.agents = [];
          self.renderAgents();
        },
        complete() {
          $('#woo-carrier-agents-throbber').hide();
        },
      });
    },

    /**
     * Show more agents when clicking the button
     */
    showMoreAgents() {
      const self = this;

      $(document).on('click', 'a#woo-carrier-agents-show-more', (e) => {
        e.preventDefault();

        self.maxResults += 5;

        Cookies.set('wca_max_results', self.maxResults);

        self.renderAgents();
      });
    },

    /**
     * Set default agent either from cookies or just the first one on the list
     */
    setDefaultAgent() {
      let value = false;

      const instanceId = this.getShippingMethodInstanceId();
      const cookieKey = `woo_carrier_agent_${instanceId}_value`;
      const cookieValue = Cookies.get(cookieKey);
      if (typeof cookieValue !== 'undefined' && cookieValue) {
        if (
          $(`.woo-carrier-agent input[type="radio"][value="${cookieValue}"]`)
            .length > 0
        ) {
          value = cookieValue;
        }
      }

      if (value === false) {
        if ($('.woo-carrier-agent input[type="radio"]').length > 0) {
          value = $('.woo-carrier-agent input[type="radio"]:first').val();
        }
      }

      if (value !== false) {
        $(`.woo-carrier-agent input[type="radio"][value="${value}"]`)
          .prop('checked', true)
          .trigger('change');
      }
    },

    /**
     * Set agent
     */
    setAgent() {
      const self = this;

      $(document).on(
        'change',
        '.woo-carrier-agent-radio input[type="radio"]',
        (e) => {
          // Add classes
          $('.woo-carrier-agent.active').removeClass('active');
          $(this).closest('.woo-carrier-agent').addClass('active');

          // Save agent to cookies
          // THIS IS ENERVENT MODIFIED
          // const cookieKey = `woo_carrier_agent_${self.getShippingMethodInstanceId()}_value`;
          // Cookies.set(cookieKey, $(this).val());
          // If using Klarna Checkout, save agent via AJAX
          if (self.isKlarnaCheckout() || self.isKlarnaCheckoutV3()) {
            self.saveAgentAjax(e.target.defaultValue);
          }
        }
      );
    },

    /**
     * Select agent when clicking it
     */
    selectAgent() {
      $(document).on('click', '.woo-carrier-agent', () => {
        $('.woo-carrier-agent-radio input[type="radio"]', this)
          .prop('checked', true)
          .trigger('change');
      });
    },

    /**
     * Get search postcode
     */
    getSearchPostcode() {
      return $('input[name="woo-carrier-agents-postcode"]').val();
    },

    /**
     * Get agent data by id
     */
    findAgentById(agentId) {
      // Find agent from the agent data
      let agent = null;
      for (let i = 0; i < this.agents.length; i += 1) {
        agent = this.agents[i];
        if (agent.id === agentId) {
          break;
        }
      }

      return agent;
    },

    /**
     * Save search postcode to cookies when changing it
     */
    saveSearchPostcode() {
      $(document).on(
        'change',
        'input[name="woo-carrier-agents-postcode"]',
        () => {
          Cookies.set('wca_postcode', $(this).val());
        }
      );
    },

    /**
     * Save agent to session via AJAX
     */
    saveAgentAjax(agentId) {
      const agent = this.findAgentById(agentId);

      if (agent !== null) {
        const data = {
          action: 'wca_save_agent',
          agent_id: agent.id,
          agent_data: agent,
        };

        jQuery.ajax({
          url: wooCarrierAgentsAjax.ajaxurl,
          data,
          method: 'POST',
        });
      }
    },

    /**
     * Show / hide "Show more" button depending on if there are unshown agents
     */
    toggleShowMore() {
      if (this.maxResults >= this.agents.length) {
        $('a#woo-carrier-agents-show-more').hide();
        $('#woo-carrier-agents-displaying-all').show();
      } else {
        $('a#woo-carrier-agents-show-more').show();
        $('#woo-carrier-agents-displaying-all').hide();
      }
    },

    /**
     * Show / hide agents when changing the shipping method
     */
    toggleAgents() {
      $('.carrier-agents-postcode-search').toggle(
        this.shippingMethodHasAgents()
      );

      return this.shippingMethodHasAgents();
    },

    /**
     * Checks whether the current shipping method has agent search
     * NOTE:
     * THIS IS THE ENERVENT MODIFIED PART
     */
    shippingMethodHasAgents() {
      const instanceId = this.getShippingMethodInstanceId();
      const myPackMethod = this.getShippingMyPackMethod();

      // If sub
      const recurTotal = $('.recurring-totals');

      if (typeof wooCarrierAgentsInstanceIds === 'undefined') {
        return false;
      }

      // Get all checked values
      const checkboxValues = $('input[type=radio]:checked')
        .map((_, el) => $(el).val())
        .get();

      // Dont show carrier agents if PostNord My Pack Home selected or Pickup from factory
      const hasPostNordDeliveryToHome = checkboxValues.findIndex(
        (element) =>
          // TODO: smarter, now requires maintenance when new postnord methods are added
          element.includes('postnord:31') ||
          element.includes('postnord:26') ||
          element.includes('postnord:22') ||
          element.includes('postnord:23') ||
          element.includes('postnord:24')
      );

      // If doesnt include klarna kco then proceed and check if postnord mypack is selected
      if (!checkboxValues.includes('kco')) {
        if (hasPostNordDeliveryToHome >= 0) {
          return false;
        }

        const hasPostNord = checkboxValues.findIndex((element) =>
          element.includes('postnord')
        );

        if (hasPostNord >= 0) {
          return (
            wooCarrierAgentsInstanceIds.indexOf(parseInt(instanceId, 10)) !== -1
          );
        }
        return false;
      }

      if (hasPostNordDeliveryToHome >= 0) {
        return false;
      }

      // No checkboxes at this point, if PostNord MyPack is the only shipping option
      if (myPackMethod) {
        return (
          wooCarrierAgentsInstanceIds.indexOf(parseInt(instanceId, 10)) !== -1
        );
      }
      if (recurTotal.length > 0) {
        return (
          wooCarrierAgentsInstanceIds.indexOf(parseInt(instanceId, 10)) !== -1
        );
      }
      return false;
    },

    /**
     * Get preselected shipping method (only for Klarna Checkout)
     */
    getPreselectedShippingMethod() {
      if (
        this.isKlarnaCheckout() &&
        typeof wooCarrierAgentsChosenMethod !== 'undefined'
      ) {
        return wooCarrierAgentsChosenMethod;
      }

      return false;
    },

    /**
     * Get current shipping method
     *
     * NOTE:
     * THIS IS THE ENERVENT MODIFIED PART
     */
    getShippingMyPackMethod() {
      return wooCarrierAgentsMethod;
    },

    /**
     * Get currently selected shipping method
     *
     * NOTE:
     * THIS IS THE ENERVENT MODIFIED PART
     */
    getShippingMethod() {
      return wooCarrierAgentsInstanceValue;
    },

    /**
     * Get selected shipping method instance ID
     *
     * NOTE:
     * THIS IS THE ENERVENT MODIFIED PART
     */
    getShippingMethodInstanceId() {
      return wooCarrierAgentsInstanceId;
    },

    /**
     * Get selected shipping method type
     */
    getShippingMethodType() {
      const shippingMethod = this.getShippingMethod();

      if (shippingMethod !== false && shippingMethod.indexOf(':') !== -1) {
        const ids = shippingMethod.split(':');

        return ids[0];
      }

      return null;
    },
  };

  wooCarrierAgents.init();
});
